module.exports = __webpack_public_path__ + "static/img/image055.fa36470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image055.png
// module id = nMaO
// module chunks = 1